// extracted by mini-css-extract-plugin
export var blue = "_1b-f";
export var brand = "_1b-b";
export var darkGrey = "_1b-e";
export var disabled = "_1b-4";
export var disabledSubtle = "_1b-5";
export var error = "_1b-6";
export var green = "_1b-g";
export var grey = "_1b-d";
export var icon = "_1b-0";
export var inherit = "_1b-a";
export var lightGrey = "_1b-c";
export var orange = "_1b-i";
export var pink = "_1b-k";
export var primary = "_1b-1";
export var purple = "_1b-l";
export var red = "_1b-j";
export var secondary = "_1b-2";
export var success = "_1b-9";
export var tertiary = "_1b-3";
export var warning = "_1b-7";
export var warningSecondary = "_1b-8";
export var white = "_1b-m";
export var yellow = "_1b-h";